"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReallyDefined = isReallyDefined;
function isReallyDefined(value) {
    return value !== null && value !== undefined;
}
